import { render, staticRenderFns } from "./AocView.vue?vue&type=template&id=34f76d29&"
import script from "./AocView.vue?vue&type=script&lang=js&"
export * from "./AocView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports